module.exports = __webpack_public_path__ + "img/1150818895.af6f282e.jpg";